module.exports = __webpack_public_path__ + "img/appleStore.25a88e18.png";